function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVideo = function SvgIconVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    }
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: "1.26px"
    },
    d: "M755 253.065h8.948v7.847H755z",
    transform: "matrix(1.52506 0 0 1.64062 -1149.801 -409.045)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m767.665 248.365-12.665 4.7v7.847l12.665 4.7v-17.247Z",
    style: {
      fill: "none",
      strokeWidth: "3.24px"
    },
    transform: "matrix(.53788 0 0 .68596 -390.835 -163.707)"
  }));
};
export default SvgIconVideo;